import { useEffect, useRef } from 'react'
import NoSleep from 'nosleep.js'

export const usePreventScreensaver = () => {
  const noSleepRef = useRef<NoSleep | null>(null)
  
  useEffect(() => {
    noSleepRef.current = new NoSleep()
    
    // Enable on first user interaction
    const enableOnInteraction = () => {
      noSleepRef.current?.enable()
      // Remove listener after first activation
      document.removeEventListener('click', enableOnInteraction)
      document.removeEventListener('touchstart', enableOnInteraction)
      document.removeEventListener('keydown', enableOnInteraction)
    }
    
    document.addEventListener('click', enableOnInteraction)
    document.addEventListener('touchstart', enableOnInteraction)
    document.addEventListener('keydown', enableOnInteraction)
    
    return () => {
      noSleepRef.current?.disable();
      document.removeEventListener('click', enableOnInteraction)
      document.removeEventListener('touchstart', enableOnInteraction)
      document.removeEventListener('keydown', enableOnInteraction)
    }
  }, [])
}